import { Component, type ReactNode } from 'react'
import { Button } from '@/components/ui/button'

type Props = {
  children: ReactNode
  fallback?: ReactNode
}

type State = {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback

      return (
        <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 p-6 text-center">
          <div className="text-4xl">😵</div>
          <h2 className="text-lg font-semibold">エラーが発生しました</h2>
          <p className="max-w-sm text-sm text-muted-foreground">
            予期しないエラーが発生しました。再試行するか、ページを再読み込みしてください。
          </p>
          {this.state.error && (
            <pre className="max-w-sm overflow-auto rounded-md bg-muted p-3 text-left text-xs text-muted-foreground">
              {this.state.error.message}
            </pre>
          )}
          <div className="flex gap-2">
            <Button variant="outline" onClick={() => window.location.reload()}>
              再読み込み
            </Button>
            <Button onClick={this.handleReset}>
              再試行
            </Button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
